var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type == 'detail')?_c('Detail',{attrs:{"selectData":_vm.selectData},on:{"goList":_vm.goList}}):_vm._e(),(_vm.type == 'list')?_c('List',{attrs:{"id":_vm.id,"parent":_vm.parent},on:{"goDetail":_vm.goDetail}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }